import React, { useCallback, useRef, useEffect, useState } from 'react';
import {
  FiLogIn,
  FiMail,
  FiLock,
  FiKey,
  FiMessageCircle,
} from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
import { rgb } from 'polished';
import {
  FaConnectdevelop,
  FaLock,
  FaHandPointUp,
  FaCertificate,
  FaTicketAlt,
  FaVideo,
  FaAward,
  FaSlideshare,
  FaKey,
} from 'react-icons/fa';
import { MdColorLens, MdMessage } from 'react-icons/md';
import { AiFillSafetyCertificate } from 'react-icons/ai';
import { IconType } from 'react-icons/lib';
import AreaExposicao from '../AreaExposicao';
import AreaInstitucional from '../AreaInstitucional';
import { ContactIcons, WhatsappIcon } from '../../components/Menu';
import Whatsapp from '../../components/Whatsapp';
import { logo } from '../../config';
import {
  Container,
  SecondaryContainer,
  ContainerWhite,
  GreyContainer,
  Capa,
  ProgramContainer,
  Sponsors,
  Photo,
} from './styles';

import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';
import { useModal } from '../../hooks/Modal';


import CapaEvento from '../HomeCapa';

import { usePages } from '../../hooks/Pages';

import SponsorsList from '../Sponsors';

import { usePlatformData } from '../../hooks/Platform';
import { SpeakersContainer } from '../../components/SpeakersGrid';
import Sobre from '../Sobre';
import { Info } from '../../components/Chat/styles';
import Speakers from '../Speakers';
import Program from '../Program';

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const Home: React.FC = () => {
  const validItems = {
    capa :  <CapaEvento/>,
    sponsors : <SponsorsList/>,
    speakers : <Speakers/>,
   
    sobre : <Sobre/>,
    info : <Info/>
  }


  const {platform} = usePlatformData();
  return (
    <>
    {platform?.homeSlides?.map( content => {
      return content.status === "2" && validItems?.[content?.model] ? validItems?.[content?.model] : <></>
    })}
     
    </>
  );
};
export default Home;
